module.exports = __webpack_public_path__ + "static/media/EmailTransper.9ed831f7.svg";